import CommonToast from './CommonToast'
import ConfirmDialog from './ConfirmDialog'

const registerPlugin = (app) => {
  app.use(CommonToast)
  app.use(ConfirmDialog)
}

export default registerPlugin
